import { createSelector } from '@ngrx/store';
import { RootState } from '../../root-store/root.state';
import { SeTimelineState } from './se-timeline.state';

export const selectSeTimelineFeatureState = (state: RootState) => state.seTimeline;

// feature
export const selectSeTimelineFeature = createSelector(
    selectSeTimelineFeatureState,
    (state: SeTimelineState) => state.feature
);

//data
export const selectSeTimelineData = createSelector(
    selectSeTimelineFeatureState,
    (state: SeTimelineState) => state.clinicalHistory.data
);

//filters
export const selectSeTimelineFilters = createSelector(
    selectSeTimelineFeatureState,
    (state: SeTimelineState) => state.clinicalHistory.filters
);

// tutto lo stato
export const selectSeTimelineDataState = createSelector(
    selectSeTimelineFeatureState,
    (state: SeTimelineState) => state.clinicalHistory
);

// report
export const selectSeTimelineReport = createSelector(
    selectSeTimelineFeatureState,
    (state: SeTimelineState) => state.reportHistory.report
);

//report filters
export const selectSeTimelineReportFilters = createSelector(
    selectSeTimelineFeatureState,
    (state: SeTimelineState) => state.reportHistory.filters
);

// tutto lo stato di reportHistory
export const selectSeTimelineReportState = createSelector(
    selectSeTimelineFeatureState,
    (state: SeTimelineState) => state.reportHistory
);
